<script lang="ts">
	import '@shared/fonts.css';
	import '../app.css';
	import { page } from '$app/stores';
	import Header from '$lib/components/Header.svelte';
	import Footer from '$lib/components/Footer.svelte';

	let { data, children } = $props();
</script>

<svelte:head>
	<meta name="author" content={data.site.name} />
	<link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml" />
</svelte:head>

<Header site={data.site} pathname={$page.url.pathname} />
{@render children()}
<Footer site={data.site} />
